import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOregistroProntuario = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)
    const condicional = useSelector((state) => state.addForm.modulos)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="REGISTRO EM PRONTUÁRIO" />
                    <div style={{ textAlign: "left" }}>
                        {/* <Input label="Profissional" nome="profissional" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="50vw" widthMobile="80vw" marginR="3vw" /> */}
                        <Select label="Dispõe de registro de prontuário" nome="tor" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim, Físico", "Sim, Eletrônico", "Sim, Físico e Eletrônico", "Não"]} />
                        <Select label="Anamnese" nome="toanamnese" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não se aplica"]} />
                        <Select label="Avaliação Clínica, Educacional ou Social" nome="toplanoTratamento" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não se aplica"]} />
                        <Select label="Diagnóstico e Prognóstico terapêutico ocupacional ou parecer" nome="toevolucao" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não se aplica"]} />
                        <Select label="Assinatura e Carimbo" nome="toassinatura" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não Se Aplica"]} />
                        <Select label="Evolução da condição de saúde, qualidade de vida e participação social" nome="toevolucaodacondicao" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não Se Aplica"]} />
                        <Select label="Plano terapêutico ocupacional" nome="toplanoterapeutico" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não Se Aplica"]} />
                        <Select label="Registros disponíveis no local de atendimento" nome="toregistrolocalatendimento" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não Se Aplica"]} />
                        {RenderCondicional()}
                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Conformidade com a Resolução COFFITO 415/2012"
                            nome="conformidade415" modulo={modulo} index={n}
                            widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoesProntuario" />
                </Caixa>
            )

            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                if (array[modulo][n]["toanamnese"] === "Não" || array[modulo][n]["toplanoTratamento"] === "Não" ||
                    array[modulo][n]["toevolucao"] === "Não" || array[modulo][n]["toassinatura"] === "Não" ||
                    array[modulo][n]["toevolucaodacondicao"] === "Não" || array[modulo][n]["toplanoterapeutico"] === "Não" ||
                    array[modulo][n]["toregistrolocalatendimento"] === "Não") {
                    campos.push(
                        <div>
                            <Input label="Nº de Profissionais que descumprem" nome="toprofissionaisdescumprem" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                            {RenderProfissionaisDescumprem()}
                        </div>
                    )
                }

                function RenderProfissionaisDescumprem() {
                    let campos = []
                    if (condicional[modulo].length > 0) var array = condicional
                    else var array = ficha
                    var quantidade = array[modulo][n]["toprofissionaisdescumprem"]
                    if (array[modulo][n]["toprofissionaisdescumprem"]) {
                        for (let i = 0; i < quantidade; i++) {
                            campos.push(
                                <div>
                                    <Input label="Nome do Profissional" nome="tonomeprofissional" modulo={modulo} index={n} subModulo="tonomeprofissional" indexSub={i}
                                        componentDisplay="inline-grid" widthWeb="37vw" widthMobile="80vw" marginR="3vw" />

                                    <Input label="Nº CREFITO" nome="tocrefitoprofissional" modulo={modulo} index={n} subModulo="tocrefitoprofissional" indexSub={i}
                                        componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                                </div>
                            )
                        }
                    }
                    return campos
                }
                return campos
            }
        }
        return partes
    }
}

export default TOregistroProntuario